(() => {
  if (customElements.get('gripped-cart-upsell')) return;
  class GrippedCartUpsell extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('change', () => this.sync(), { signal });
      this.addEventListener('click', event => { if (event.target.closest('[data-upsell-add]')) this.add(); }, { signal });
      document.addEventListener('cart:update', () => queueMicrotask(() => { if (this.isConnected) this.sync(); }), { signal });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    read(selector, fallback) { try { return JSON.parse(this.querySelector(selector)?.textContent || 'null') || fallback; } catch { return fallback; } }
    sync() {
      this.variants = this.read('[data-upsell-variants]', []);
      this.copy = this.read('[data-upsell-copy]', {});
      const selects = [...this.querySelectorAll('[data-upsell-option]')];
      const colour = selects.find(select => Number(select.dataset.upsellOption) === Number(this.dataset.colourIndex));
      const size = selects.find(select => Number(select.dataset.upsellOption) === Number(this.dataset.sizeIndex));
      if (colour) [...colour.options].forEach(option => { option.disabled = !this.variants.some(v => v.available && v.options[Number(this.dataset.colourIndex)] === option.value); });
      if (colour?.selectedOptions[0]?.disabled) colour.value = [...colour.options].find(option => !option.disabled)?.value || '';
      if (size) {
        [...size.options].forEach(option => { option.disabled = !this.variants.some(v => v.available && v.options[Number(this.dataset.sizeIndex)] === option.value && (!colour || v.options[Number(this.dataset.colourIndex)] === colour.value)); });
        if (size.selectedOptions[0]?.disabled) size.value = [...size.options].find(option => !option.disabled)?.value || '';
      }
      this.variant = this.variants.find(v => v.available && selects.every(select => v.options[Number(select.dataset.upsellOption)] === select.value));
      const button = this.querySelector('[data-upsell-add]');
      if (button) button.disabled = this.busy || !this.variant;
      if (this.variant) {
        this.querySelector('[data-upsell-price]').textContent = this.variant.price;
        const image = this.querySelector('img');
        if (image && this.variant.image) { image.removeAttribute('srcset'); image.src = this.variant.image; }
      }
    }
    showError(message) { const node = this.querySelector('[data-upsell-error]'); node.textContent = message; node.hidden = false; }
    async add() {
      if (this.busy) return;
      this.sync();
      if (!this.variant) { this.showError(this.copy.unavailable); return; }
      const variantId = this.variant.id;
      this.busy = true;
      const button = this.querySelector('[data-upsell-add]');
      button.disabled = true; button.setAttribute('aria-busy', 'true');
      this.querySelector('[data-upsell-error]').hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        // Recheck the current cart before adding, including changes in another tab.
        const beforeResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!beforeResponse.ok) throw new Error(this.copy.error);
        const before = await beforeResponse.json();
        if (before.items.some(item => String(item.product_id) === this.dataset.productId || item.handle?.split('-x')[0] === this.dataset.handle)) {
          this.showError(this.copy.duplicate);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{resource:before,sourceId:'gripped-cart-upsell',data:{source:'gripped-cart-upsell',itemCount:before.item_count}} }));
          return;
        }
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.dataset.sectionId).filter(Boolean))].slice(0,5);
        const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items:[{id:variantId,quantity:1}],sections,sections_url:location.pathname}) });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || this.copy.error);
        // Hide immediately so a stale card can never offer the newly added product.
        this.hidden = true;
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        const cart = cartResponse.ok ? await cartResponse.json() : {...before,item_count:before.item_count+1};
        document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true,detail:{resource:cart,sourceId:'gripped-cart-upsell',data:{source:'gripped-cart-upsell',itemCount:cart.item_count,sections:payload.sections}}}));
      } catch (error) { this.showError(error.message || this.copy.error); }
      finally { this.busy=false; if (this.isConnected) { button.removeAttribute('aria-busy'); this.sync(); } }
    }
  }
  customElements.define('gripped-cart-upsell', GrippedCartUpsell);
})();
